import { Collapse } from "antd";
import { translate } from "../../../core";
import { Container } from "../../../core/component";
import { InventorySettingsContent } from "../../inventory/component/InventorySettingsContent";
import { ContactSettingsContent } from "../../contact/component/ContactSettingsContent";
import { ShopSettingsContent } from "../../shop/component/ShopSettingsContent";
import { PrinterSettingsContent } from "./printer/PrinterSettingsContent";
import { Profile } from "../../user/component/Profile";
import { AppraisalSettings } from "../../appraisal/component/AppraisalSettings";

const { Panel } = Collapse;

export const Settings = () => {
  return (
    <Container>
      <Collapse>
        <Panel header={translate("profile")} key="profile">
          <Profile />
        </Panel>

        <Panel header={translate("appraisal")} key="appraisal">
          <AppraisalSettings />
        </Panel>

        <Panel header={translate("contact")} key="contact">
          <ContactSettingsContent />
        </Panel>

        <Panel header={translate("order")} key="order"></Panel>

        <Panel header={translate("inventory")} key="inventory">
          <InventorySettingsContent />
        </Panel>

        <Panel header={translate("shop")} key="shop">
          <ShopSettingsContent />
        </Panel>

        <Panel header={translate("printer")} key="printer">
          <PrinterSettingsContent />
        </Panel>
      </Collapse>
    </Container>
  );
};
